define('viewmodels/Weightings_Thresholds',['plugins/router', 'knockout', 'services/appsecurity', 'services/navigation', 'services/logger', 'durandal/app'], function (router, ko, appsecurity, navigation, logger, app) {
    var childRouter = router.createChildRouter()
        .makeRelative({
            //moduleId: 'viewmodels',
            fromParent: true
        }).map([
            { route: 'ControlsWeightings', moduleId: 'viewmodels/Weightings_Thresholds/ControlsWeightings', title: 'AML Controls Weightings', hash: '#Weightings_Thresholds/ControlsWeightings', type: 'list', nav: true, settings: { caption: 'fa fa-exclamation-triangle', another: 'property' } },
            { route: 'InherentWeightings', moduleId: 'viewmodels/Weightings_Thresholds/InherentWeightings', title: 'Inherent Weightings', hash: '#Weightings_Thresholds/InherentWeightings', type: 'list', nav: true, settings: { caption: 'fa fa-exclamation-triangle', another: 'property' } },
            { route: 'AMLThresholds', moduleId: 'viewmodels/Weightings_Thresholds/AMLThresholds', title: 'AML Inherent Risk Thresholds', hash: '#Weightings_Thresholds/AMLThresholds', type: 'list', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'ControlThresholds', moduleId: 'viewmodels/Weightings_Thresholds/ControlThresholds', title: 'Control Thresholds', hash: '#Weightings_Thresholds/ControlThresholds', type: 'list', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'OrganizationalLevelWeightings', moduleId: 'viewmodels/Weightings_Thresholds/OrganizationalLevelWeightings', title: 'Organizational Level Weightings', hash: '#Weightings_Thresholds/OrganizationalLevelWeightings', type: 'list', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'PCSThresholds', moduleId: 'viewmodels/Weightings_Thresholds/PCSThresholds', title: 'PCS Risk Thresholds', hash: '#Weightings_Thresholds/PCSThresholds', type: 'list', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
        ]).buildNavigationModel();

    return {
        navigation: navigation,
        router: childRouter,
        activate: activate,
        attached: attached,
        detached: detached,
        NavigateInherentWeightings: NavigateInherentWeightings,
        NavigateControlsWeightings: NavigateControlsWeightings,
        navigateAMLThresholds: navigateAMLThresholds,
        navigateControlThresholds: navigateControlThresholds,
        navigateSanctionsThresholds: navigateSanctionsThresholds,
        navigateOrganizationalLevelWeightings: navigateOrganizationalLevelWeightings,
        navigateAMLOrganizationalLevelWeightings: navigateAMLOrganizationalLevelWeightings,
        navigateSanctionsOrganizationalLevelWeightings: navigateSanctionsOrganizationalLevelWeightings,
        NavigatePCSThresholds: NavigatePCSThresholds,
        logger: logger,

        appsecurity: appsecurity,


        settingOptions: ko.computed(function () {
            return ko.utils.arrayFilter(childRouter.navigationModel(), function (route) {
                return route.type == 'list';
            });
        })

    };

    function NavigateControlsWeightings() {
        try {
            router.navigate("Weightings_Thresholds/ControlsWeightings", true);
        } catch (e) {
            var msg = 'Exception' + e + ' | Source: NavigateControlsWeightings() in Weighting_Thresholds.js';
        }
    }

    function NavigateInherentWeightings() {
        try {
            router.navigate("Weightings_Thresholds/InherentWeightings", true);
        } catch (e) {
            var msg = 'Exception' + e + ' | Source: navigateInherentWeightings() in Weighting_Thresholds.js';
        }
    }

    function navigateAMLThresholds() {
        try {

            router.navigate("Weightings_Thresholds/AMLThresholds", true);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: navigateAMLThresholds()  in Weighting_Thresholds.js';
            logger.logMessage(msg);
        }
    }
    function navigateControlThresholds() {
        try {

            router.navigate("Weightings_Thresholds/ControlThresholds", true);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: navigateControlThresholds()  in Weighting_Thresholds.js';
            logger.logMessage(msg);
        }
    }
    function navigateSanctionsThresholds() {
        try {

            router.navigate("Weightings_Thresholds/SanctionsThresholds", true);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: navigateSanctionsThresholds()  in Weighting_Thresholds.js';
            logger.logMessage(msg);
        }
    }
    function navigateOrganizationalLevelWeightings() {
        try {
            router.navigate("Weightings_Thresholds/OrganizationalLevelWeightings", true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: navigateOrganizationalLevelWeightings method in AppRoutes.js';
            logger.logMessage(msg);
        }
    }
    function navigateAMLOrganizationalLevelWeightings () {
        try {
            router.navigate("Weightings_Thresholds/AMLOrganizationalLevelWeightings", true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: NavigateAMLInherentWeightings method in AppRoutes.js';
            logger.logMessage(msg);
        }
    }

    function navigateSanctionsOrganizationalLevelWeightings() {
        try {
            router.navigate("Weightings_Thresholds/SanctionsOrganizationalLevelWeightings", true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: NavigateAMLInherentWeightings method in AppRoutes.js';
            logger.logMessage(msg);
        }
    }

    function NavigatePCSThresholds() {
        try {

            router.navigate("Weightings_Thresholds/PCSThresholds", true);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: NavigatePCSThresholds()  in Weighting_Thresholds.js';
            logger.logMessage(msg);
        }
    }

    function activate() {
    }


    function detached() {
        $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(5)).removeClass('active')
    };

    function attached() {
        $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(5)).addClass('active')


    }

});





